import { convertCellTopList } from '@/common/converter/convert-cell-top-list'

/**
 * 홈 데이터(신)를 받아 리스트 데이터(구)로 변환
 * category sub 에서 호출 시 사용
 * 홈 데이터 / 카탈로그 데이터 모두 신 규격
 */
export const convertList = async (homeData) => {
  const { version = '', type = '', layout = {} } = homeData
  const { catalogList = [] } = layout?.catalog

  return {
    type,
    sub_type: '',
    version,
    gen_time: '',
    cell_toplist: await convertCellTopList(catalogList),
    filter: homeData?.layout?.filter ?? {},
    tvcut_bybroadcaster_list: {},
  }
}
